export default __webpack_public_path__ + "static/media/T13.3572dc49.jpg";